function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('d3-geo')) : typeof define === 'function' && define.amd ? define(['exports', 'd3-geo'], factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.geoAlbersUsaTerritories = {}, global.d3));
})(this, function (exports, d3Geo) {
  'use strict';

  var epsilon = 0.000001;

  function multiplex(streams) {
    return {
      point: function point(x, y) {
        var _iterator = _createForOfIteratorHelper(streams),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var s = _step.value;
            s.point(x, y);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      },
      sphere: function sphere() {
        var _iterator2 = _createForOfIteratorHelper(streams),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var s = _step2.value;
            s.sphere();
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      },
      lineStart: function lineStart() {
        var _iterator3 = _createForOfIteratorHelper(streams),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var s = _step3.value;
            s.lineStart();
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      },
      lineEnd: function lineEnd() {
        var _iterator4 = _createForOfIteratorHelper(streams),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var s = _step4.value;
            s.lineEnd();
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      },
      polygonStart: function polygonStart() {
        var _iterator5 = _createForOfIteratorHelper(streams),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var s = _step5.value;
            s.polygonStart();
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      },
      polygonEnd: function polygonEnd() {
        var _iterator6 = _createForOfIteratorHelper(streams),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var s = _step6.value;
            s.polygonEnd();
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      }
    };
  }

  function geoAlbersUsaTerritories() {
    var cache,
        cacheStream,
        lower48 = d3Geo.geoAlbers(),
        lower48Point,
        alaska = d3Geo.geoConicEqualArea().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]),
        alaskaPoint,
        hawaii = d3Geo.geoConicEqualArea().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]),
        hawaiiPoint,
        puertoRico = d3Geo.geoConicEqualArea().rotate([66, 0]).center([0, 18]).parallels([8, 18]),
        puertoRicoPoint,
        guamMariana = d3Geo.geoConicEqualArea().rotate([-145, 0]).center([0, 16]).parallels([10, 20]),
        guamMarianaPoint,
        americanSamoa = d3Geo.geoConicEqualArea().rotate([170, 0]).center([0, -14]).parallels([-14, 0]),
        americanSamoaPoint,
        _point,
        pointStream = {
      point: function point(x, y) {
        _point = [x, y];
      }
    };

    function albersUsaTerritories(coordinates) {
      var x = coordinates[0],
          y = coordinates[1];
      return _point = null, (lower48Point.point(x, y), _point) || (alaskaPoint.point(x, y), _point) || (hawaiiPoint.point(x, y), _point) || (puertoRicoPoint.point(x, y), _point) || (guamMarianaPoint.point(x, y), _point) || (americanSamoaPoint.point(x, y), _point);
    }

    albersUsaTerritories.invert = function (coordinates) {
      var k = lower48.scale(),
          t = lower48.translate(),
          x = (coordinates[0] - t[0]) / k,
          y = (coordinates[1] - t[1]) / k;
      return (y >= 0.12 && y < 0.234 && x >= -0.225 && x < -0.185 ? alaska : y >= 0.166 && y < 0.234 && x >= -0.185 && x < -0.08 ? hawaii : y >= 0.204 && y < 0.234 && x >= 0.3 && x < 0.38 ? puertoRico : y >= 0.05 && y < 0.204 && x >= -0.415 && x < -0.225 ? guamMariana : y >= 0.18 && y < 0.234 && x >= -0.415 && x < -0.225 ? americanSamoa : lower48).invert(coordinates);
    };

    albersUsaTerritories.stream = function (stream) {
      return cache && cacheStream === stream ? cache : cache = multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream), puertoRico.stream(stream), guamMariana.stream(stream), americanSamoa.stream(stream)]);
    };

    albersUsaTerritories.precision = function (_) {
      if (!arguments.length) return lower48.precision();
      lower48.precision(_);
      alaska.precision(_);
      hawaii.precision(_);
      puertoRico.precision(_);
      guamMariana.precision(_);
      americanSamoa.precision(_);
      return reset();
    };

    albersUsaTerritories.scale = function (_) {
      if (!arguments.length) return lower48.scale();
      lower48.scale(_);
      alaska.scale(_ * 0.35);
      hawaii.scale(_);
      puertoRico.scale(_);
      guamMariana.scale(_);
      americanSamoa.scale(_);
      return albersUsaTerritories.translate(lower48.translate());
    };

    albersUsaTerritories.translate = function (_) {
      if (!arguments.length) return lower48.translate();
      var k = lower48.scale(),
          x = +_[0],
          y = +_[1];
      lower48Point = lower48.translate(_).clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]]).stream(pointStream);
      alaskaPoint = alaska.translate([x - 0.275 * k, y + 0.201 * k]).clipExtent([[x - 0.425 * k + epsilon, y + 0.12 * k + epsilon], [x - 0.185 * k - epsilon, y + 0.234 * k - epsilon]]).stream(pointStream);
      hawaiiPoint = hawaii.translate([x - 0.18 * k, y + 0.212 * k]).clipExtent([[x - 0.185 * k + epsilon, y + 0.166 * k + epsilon], [x - 0.08 * k - epsilon, y + 0.234 * k - epsilon]]).stream(pointStream);
      puertoRicoPoint = puertoRico.translate([x + 0.335 * k, y + 0.224 * k]).clipExtent([[x + 0.3 * k, y + 0.204 * k], [x + 0.38 * k, y + 0.234 * k]]).stream(pointStream);
      guamMarianaPoint = guamMariana.translate([x - 0.415 * k, y + 0.14 * k]).clipExtent([[x - 0.45 * k, y + 0.05 * k], [x - 0.39 * k, y + 0.21 * k]]).stream(pointStream);
      americanSamoaPoint = americanSamoa.translate([x - 0.415 * k, y + 0.215 * k]).clipExtent([[x - 0.45 * k, y + 0.21 * k], [x - 0.39 * k, y + 0.234 * k]]).stream(pointStream);
      return reset();
    };

    function reset() {
      cache = cacheStream = null;
      return albersUsaTerritories;
    }

    return albersUsaTerritories.scale(1070);
  }

  exports.geoAlbersUsaTerritories = geoAlbersUsaTerritories;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});